module.exports = __webpack_public_path__ + "static/img/GoogleLogo.b75aecaf.png";